// extracted by css-extract-rspack-plugin
export default {"CompactExportAsPdfButton":"Rirjq","ParametersVisibleWithNoTabs":"Bz6Y5"};